import {useParams, useRouteMatch} from 'react-router-dom';
import {ExternalAccountsAssociations} from '../../../../../../../components/external-accounts-associations/external-accounts-associations';

export default function SeniorExternalAccountsSystemAdministratorOfficeScreen() {
  // Get params
  let {id}: {id?: string} = useParams();

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <ExternalAccountsAssociations
      userId={id || ''}
      associateAccountUrl={
        url.charAt(url.length - 1) === '/' ? `${url}associate` : `${url}/associate`
      }
      accountRowBaseUrl={url.charAt(url.length - 1) === '/' ? url.slice(0, -1) : url}
    />
  );
}
